"use client";

import { Container } from "@/components/ui/container";
import { Reveal } from "@/components/ui/reveal";
import { aboutCompany } from "@/lib/data/homepage";

/**
 * About — Editorial layout. Mission statement + values grid + track
 * record as a striking stat wall.
 */
export function About() {
  return (
    <section id="about" className="relative section-pad">
      <Container>
        <div className="grid lg:grid-cols-[1fr_1.3fr] gap-10">
          <Reveal>
            <div className="sticky top-24">
              <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full glass eyebrow-tiny text-[var(--color-denim)]">
                <span className="h-1.5 w-1.5 rounded-full bg-[var(--color-denim)]" />
                {aboutCompany.eyebrow}
              </span>
              <h2 className="mt-6">
                {aboutCompany.title}
              </h2>
              <p className="mt-5 text-body leading-[1.7] text-[rgb(var(--fg-muted))] max-w-md">
                {aboutCompany.desc}
              </p>
              <div className="mt-8 rounded-2xl glass p-6 relative overflow-hidden">
                <div className="absolute -top-12 -right-12 h-32 w-32 rounded-full bg-[var(--color-crimson)] opacity-15 blur-3xl pointer-events-none" />
                <div className="relative">
                  <div className="eyebrow-tiny text-[var(--color-crimson)] mb-2">
                    Our Mission
                  </div>
                  <p className="text-base font-medium leading-relaxed italic">
                    "{aboutCompany.mission}"
                  </p>
                </div>
              </div>
            </div>
          </Reveal>

          <Reveal delay={120}>
            <div>
              {/* Values grid */}
              <div className="mb-10">
                <div className="eyebrow-tiny text-[rgb(var(--fg-subtle))] mb-4">
                  Our Values
                </div>
                <div className="grid sm:grid-cols-2 gap-3">
                  {aboutCompany.values.map((v, i) => {
                    const accents = ["var(--color-crimson)", "var(--color-purple)", "var(--color-cyan)", "var(--color-emerald)"];
                    return (
                      <div
                        key={v.title}
                        className="rounded-2xl glass p-5 h-full"
                      >
                        <div className="display-stat-sm" style={{ color: accents[i] }}>
                          0{i + 1}
                        </div>
                        <h3 className="font-bold text-base leading-tight mt-2">{v.title}</h3>
                        <p className="mt-1.5 text-body-xs leading-relaxed text-[rgb(var(--fg-muted))]">{v.desc}</p>
                      </div>
                    );
                  })}
                </div>
              </div>

              {/* Track record stat wall */}
              <div>
                <div className="eyebrow-tiny text-[rgb(var(--fg-subtle))] mb-4">
                  Our Track Record
                </div>
                <div className="rounded-3xl glass p-6">
                  <div className="grid grid-cols-2 sm:grid-cols-3 gap-px bg-[rgb(var(--border)/0.15)]">
                    {aboutCompany.track.map((t, i) => (
                      <div key={t.label} className="bg-[rgb(var(--bg))] p-5 text-center">
                        <div className="display-stat-sm" style={{ color: ["var(--color-crimson)", "var(--color-purple)", "var(--color-cyan)", "var(--color-emerald)", "var(--color-amber)", "var(--color-coral)"][i] }}>
                          {t.value}
                        </div>
                        <div className="eyebrow-tiny text-[rgb(var(--fg-subtle))] mt-2 font-semibold">
                          {t.label}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </Reveal>
        </div>
      </Container>
    </section>
  );
}
